import React, { useEffect }  from 'react';
// import heroImage from '../../src/static/images/Image Jul 16, 2025, 10_43_27 PM.png';
import heroImage from '../../static/images/Coffee shop-bro.svg';


function Hero() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="hero-section py-5">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 text-center text-lg-start">
                        <h1 className="hero-title mb-4">
                            A digital platform for restaurants, built like a startup
                        </h1>
                        <p className="hero-subtext mb-4">
                            Professional apps and websites for restaurants and bars. Seamlessly connect your menu,
                            manage content, and highlight your venue online.
                        </p>
                        <a href="/nectr-design-frontend/src/static" className="btn btn-accent-primary">Get started</a>
                    </div>
                    <div className="col-lg-6 text-center mt-5 mt-lg-0">
                        <img src={heroImage} alt="Hero Illustration" className="img-fluid hero-image" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
// import React from 'react';
// import '../static/Hero.css'
//
// function Hero(props) {
//     return (
//         <div id='hero'>
//             <div className='hero-container'>
//                 <div className='row'>
//                     <div className='align-content-center'>
//                         <h1>Web solutions for your restaurant or bar</h1>
//                         <div className='get-started-container'>
//                             <div className='row'>
//                                 <div className='col-6 my-auto'>
//                                     <h2 className="text-center">Get Started Today</h2>
//                                 </div>
//                                 <div className='col-6 mt-4 sign-up-col'>
//                                     <img style={{width: 191, height: 46}} src='https://storage.googleapis.com/nectrjobs-bucket-media/btn_google_signin_light_normal_web%402x.png' alt='google'/>
//                                     <div style={{color: 'white'}}>or</div>
//                                     <button style={{color: 'white'}} type="button" className="btn btn-link mb-2">Sign up with your company email</button>
//                                 </div>
//
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//
//
//         </div>
//     );
// }
//
// export default Hero;